import { TableCell, TableCellProps } from '@mui/material';
import React from 'react';
import { formatDateTime, isLastHeartbeatStale } from '../../utils';

interface HeartbeatCellProps {
  tableCellProps?: TableCellProps,
  serialNumber?: string,
  value?: string
  isStale?: boolean;
  subscriptionStatus?: string;
}

function HeartbeatCell({ tableCellProps, value, isStale, subscriptionStatus }: HeartbeatCellProps): React.ReactElement {
  const isSuspended = subscriptionStatus === 'device_suspended' || subscriptionStatus === 'device_expired';

  return (
    <TableCell {...tableCellProps}
      align="left"
      onDoubleClick={(e) => {
        e.stopPropagation();
        if (value) {
          navigator.clipboard.writeText(value);
        }
      }}
      sx={isSuspended ? { backgroundColor: '#a35d16' } : isStale ? { backgroundColor: '#65242f' } : {}}
    >
      {value && formatDateTime(value)}
    </TableCell >
  )
}

export default HeartbeatCell;